"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function compileColorsStyle(branding) {
    const { colors = {} } = branding;
    const internal = colors === null || colors === void 0 ? void 0 : colors.internal;
    const main = colors === null || colors === void 0 ? void 0 : colors.main;
    const border = colors === null || colors === void 0 ? void 0 : colors.border;
    return (0, utils_1.process)({
        'view-default-control-checked-background': main,
        'view-default-fill-color-action': main,
        'view-required-asterisk': main,
        'view-default-fill-color-internal': internal,
        'view-default-text-action-color': internal,
        'view-default-control-color-border': border
    });
}
exports.default = compileColorsStyle;
